import * as React from "react";
import PropTypes from "prop-types";

import { truncateString } from "../helpers/string";

export default class Truncated extends React.PureComponent {
    render() {
        const {
            type: ComponentType,
            maxLength,
            children,
            ...otherProps
        } = this.props;

        const content = React.Children.toArray(children)[0];
        let display = content;
        if (content && content.length > maxLength) {
            display = truncateString(content, maxLength);

            // If the element doesn't already have a title property, add one with the full content. This should become
            // a tooltip in most browsers.
            if (!otherProps.title) {
                otherProps.title = content;
            }
        }

        return <ComponentType {...otherProps}>{display}</ComponentType>;
    }
}

Truncated.defaultProps = {
    type: "p"
};

Truncated.propTypes = {
    type: PropTypes.string,
    maxLength: PropTypes.number.isRequired,
    children: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Truncated.js